import FacebookIcon from '@/components/icons/FacebookIcon'
import YoutubeIcon from '@/components/icons/YoutubeIcon'
import InstagramIcon from '@/components/icons/InstagramIcon'
import TikTokIcon from '@/components/icons/TikTokIcon'
import WhatsAppIcon from '@/components/icons/WhatsAppIcon'
import { FACEBOOK_URL, YOUTUBE_URL, INSTAGRAM_URL, TIKTOK_URL, WHATSAPP_CHANNEL_URL } from '@/data/contact'

const CHANNELS = [
  { label: 'Facebook', url: FACEBOOK_URL, Icon: FacebookIcon },
  { label: 'Instagram', url: INSTAGRAM_URL, Icon: InstagramIcon },
  { label: 'YouTube', url: YOUTUBE_URL, Icon: YoutubeIcon },
  { label: 'TikTok', url: TIKTOK_URL, Icon: TikTokIcon },
  { label: 'Chaîne WhatsApp', url: WHATSAPP_CHANNEL_URL, Icon: WhatsAppIcon },
]

interface SocialLinksProps {
  className?: string
  iconSize?: number
  /** Style du bouton rond — par défaut pensé pour un fond sombre (footer). */
  buttonClassName?: string
}

export default function SocialLinks({
  className = '',
  iconSize = 16,
  buttonClassName = 'w-9 h-9 bg-white/10 text-white hover:bg-white/20',
}: SocialLinksProps) {
  return (
    <div className={`flex gap-3 ${className}`}>
      {CHANNELS.map(({ label, url, Icon }) => (
        <a
          key={label}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${label} CMP Lubumbashi`}
          className={`rounded-full flex items-center justify-center transition-colors ${buttonClassName}`}
        >
          <Icon size={iconSize} />
        </a>
      ))}
    </div>
  )
}
